import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

// Rxjs
import { filter, takeUntil } from 'rxjs/operators';

import { WebcomponentsService } from '@core/service/webcomponents.service';

// Services and providers
import { GoogleTagManagerService } from '@shared/services/marketing-events';
import { AuthService } from '@auth/auth.service';
import { Subject } from 'rxjs';

// Environments

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly unSubscribe$: Subject<void>;

  constructor(
    public readonly authService: AuthService,
    private readonly gtmService: GoogleTagManagerService,
    private readonly webElementService: WebcomponentsService,
    private readonly router: Router
  ) {
    this.unSubscribe$ = new Subject();
  }

  public ngOnInit(): void {
    this.webElementService.load();
    this.gtmService.appendGtmScript('GTM-P83DLHF');
    this.setScrollToTopOnNavigation();
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private setScrollToTopOnNavigation(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.unSubscribe$)
      )
      .subscribe({
        next: () => {
          window.scrollTo(0, 0);
        },
      });
  }
}
